export default __webpack_public_path__ + "static/media/logo-signin.f0cec6c8.svg";